import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';
import {i18next} from 'picnic/core/utils/i18next';
import {copy} from  'app/utils/copy';


const
	SELECTOR_COUNTER = '.counter',
	SELECTOR_DATE = '.date',
	SELECTOR_TEXT = '.code-text',
	CLASS_INITIALIZE = 'is-initialized',
	CLASS_COPIED = 'is-copied'
;


class View extends BaseView {

	constructor(options) {
		super(options);
		this._countdown = this._countdown.bind(this);
	}

	render() {
		super.render();

		if (this.endDate) {
			this._countdown();
			this._timer = window.setInterval(this._countdown, 1000);
			this.$counter.addClass(CLASS_INITIALIZE);
		}

		return this;
	}

	events() {
		return {
			'click .code-button': this._onClick
		};
	}

	get $counter() {
		this._$counter = this._$counter || this.$el.find(SELECTOR_COUNTER);
		return this._$counter;
	}

	get $date() {
		this._$date = this._$date || this.$el.find(SELECTOR_DATE);
		return this._$date;
	}

	get endDate() {
		this._endDate = this._endDate || (this.$date.length && new Date(this.$date.data('date')));
		return this._endDate;
	}

	get isStage() {
		return !!this.$el.hasClass('is-stage-light') || !!this.$el.hasClass('is-stage-dark');
	}

	_countdown() {
		const
			diff = (this.endDate.getTime() / 1000).toFixed(0) - (new Date().getTime() / 1000).toFixed(0),
			d = Math.max(0, Math.floor(diff / 86400)),
			h = Math.max(0, (d > 1 ? 0 : d * 24) + Math.floor(diff / 3600) % 24),  // Extend hours for "hours : minutes : seconds" variant
			i = Math.max(0, Math.floor(diff / 60) % 60),
			s = Math.max(0, diff % 60),
			days = this._templateDateNumber(d, i18next.t('Days')),
			hours = this._templateDateNumber(h, i18next.t('Hours')),
			minutes = this._templateDateNumber(i, i18next.t('Minutes')),
			seconds = this._templateDateNumber(s, i18next.t('Seconds'))
		;

		let html;

		if (d > 6) {
			// Show days left
			html = `<div class="date-text">${i18next.t('{{days}} days left', {days: d})}</div>`;
		} else if (d > 1) {
			// Show days, hours and minutes
			html = [days, hours, minutes].join('<div>:</div>');
		} else {
			// Show hours, minutes and seconds
			html = [hours, minutes, seconds].join('<div>:</div>');
		}

		// Update date template
		if (html !== this.$date.html()) {
			this.$date.html(html);
		}

		// Expired
		if (diff <= 0) {
			window.clearInterval(this._timer);

			if (this.isStage) {
				this.$counter.find('.code').replaceWith(`<p>${this.$counter.data('expired-text')}</p>`);
			} else {
				this.$el.remove();
				this.destroy();
			}
		}
	}

	_templateDateNumber(value, unit) {
		return `
			<div class="date-number">
				<span class="date-value">${('0' + value).slice(-2) || '00'}</span>
				<span class="date-unit">${unit}</span>
			</div>
		`;
	}

	_onClick(e) {
		const $el = $(e.currentTarget);
		copy(this.$el.find(SELECTOR_TEXT).val());
		$el.addClass(CLASS_COPIED).text($el.data('success-text'));
	}

}


export default View;
